

















import { Component, Prop, Vue } from 'vue-property-decorator';
/* interfaces */
import MainSkill from '@/interfaces/skills/MainSkill';
import GenericObjectValue from '@/interfaces/general/GenericObjectValue';

    @Component
export default class SkillsTextsListing extends Vue {
        @Prop() private title!: string;

        @Prop() private menu!: GenericObjectValue<MainSkill>;

        @Prop() private type!: string;

        get computedClassMenu() {
          if (this.type) {
            return `skills-menu_${this.type}`;
          }
          return '';
        }

        // eslint-disable-next-line class-methods-use-this
        onMouseenter(key: string) {
          document.body.classList.add(`color-${key}`, 'rollover-on');
        }

        // eslint-disable-next-line class-methods-use-this
        onMouseleave(key: string) {
          document.body.classList.remove(`color-${key}`, 'rollover-on');
        }
}
